// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__24Hj0","footer":"ModalInfo_footer__1i_wv"};